import { connect } from 'react-redux';
import { changeFilter } from '../../../redux/actions/filter';
import { getCampaignData } from '../../../redux/actions/campaigns';
import { getOperatorData } from '../../../redux/actions/operator';
import { FilterMainCampaign } from '../../Filters';

const mapStateToProps = state => ({
  filters: state.filter.filters,
  campaignData: state.campaigns.data,
  operatorData: state.operator.data,
  loading: state.campaigns.loading,
  campaignId: state.value,
  initialValues: state.auth.user.config && state.auth.user.config.dashboard ? state.auth.user.config.dashboard.filters : null
})

const mapDispatchToProps = { getCampaignData, getOperatorData, changeFilter };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterMainCampaign)



// WEBPACK FOOTER //
// ./src/components/Panels/PanelMarketingComponent/FilterMainCampaignConnected.js